var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('div',{staticClass:"notfound"},[_c('h1',[_vm._v("403")]),_c('h2',[_vm._v("没有权限访问！")]),_c('el-button',{attrs:{"size":"large","type":"primary"},on:{"click":_vm.goback}},[_vm._v(" 返 回 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }